export default __webpack_public_path__ + "static/media/photo--lg--117.6cce2af8.jpg";